import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';
import { validateResourceUrl } from '../utils/validation.js';

export interface VolcesSeedance15ProParams {
  /**
   * 内容数组（必填），支持文本和图片URL两种类型。可包含一个文本元素，支持图生视频时可包含多个图片
   */
  content: Array<{
    /**
     * 内容类型
     * @values text | image_url
     */
    type: string;
    /**
     * 文本内容（type为text时使用）
     */
    text?: string;
    /**
     * 图片URL对象（type为image_url时使用）
     */
    image_url?: {
      /**
       * 图片URL地址或Base64数据URI
       */
      url: string;
      /**
       * 图片角色
       * @values first_frame | last_frame
       */
      role?: string;
      /**
       * 是否返回上传的最后一帧
       * @default false
       */
      return_last_frame?: boolean;
    };
  }>;
  /**
   * 服务层级
   * @values default | flex
   * @default default
   *
   * 说明：
   * - true: 返回这段视频的最后帧图片。这意味着 true 时，可通过查询到的 SE 任务会取得 2 张图片：查询到的调用任务和它生成结果中的 png、查询返回的最后帧图片。
   * - false: 不返回上传的最后帧图片。这意味着 false 时，只能查询到调用任务结果包中的图片，这个返回结果为对应任务调用中包含的 png。
   *
   * 使用者需要完成此方法手动完成支持这些分级方法，然后按照分级法提供图层进度（主要后续待迭代能够），也可以。
   * 使得场景和场景渲染更易贴图（此处）应用到此层，需按等级配送，即 GPU 迭代能够，也可能呼叫消息确认此类 "你自己没入住" 呢做出配送。
   *
   * 不支持 GPU 实现所需比对信息目标匹配依据此 service_tier、虽设立返回此类视频后需后续设置后端建议，信任该请就想让做 API 返回接 duration 字段转此。
   */
  service_tier?: 'default' | 'flex';
  /**
   * 任务到期时间（毫秒）
   * @default 172800
   *
   * 任意超时后不再轮询的最长时间（最长 约 3）。AI created at 到根据该计算，默认 172800 秒。即 48 小时。取值限制，[3600、259200]。
   * 不支持传入此 service_tier、虽设立该场景即后续者该查该至且当时该的响应时。提供该疑转状态父该点该。
   */
  execution_expires_after?: number;
  /**
   * 是否生成音频
   * @default true
   *
   * 说明：
   * - true: 根据生成的视频音效进一步音频，SeaDance 1.5 pro 根据视频音效生成音频，首协生成至少 2 次的人、根据该提类音效：1.若已达无入住无人、"你已过"、以等式否决此响手来非等。
   * - false: 根据生成的视频不生成音频
   */
  generate_audio?: boolean;
  /**
   * 分辨率
   * @values 480p | 720p | 1080p
   * @default 720p
   *
   * 视频分辨率：
   * - 480p
   * - 720p
   * - 1080p（参考图该标签不支持）
   */
  resolution?: '480p' | '720p' | '1080p';
  /**
   * 宽高比
   * @values 16:9 | 4:3 | 1:1 | 3:4 | 9:16 | 21:9 | adaptive
   * @default adaptive
   *
   * 说明：
   * 1.文生视频模式X1根据标签16:9
   * 2.图生视频模式X1根据adaptive、特别注意：参考图该标签视频X1根据16:9
   * 3.SeaDance 1.5 pro 默认X1根据adaptive
   * 不支持传统等含计算，不应该高过对的请该等高等保护下方承接。
   * 16:9
   * 4:3
   * 1:1
   * 3:4
   * 9:16
   * 21:9
   * adaptive：根据所有等增图的内对，自动该等合适的宽高比
   */
  ratio?: '16:9' | '4:3' | '1:1' | '3:4' | '9:16' | '21:9' | 'adaptive';
  /**
   * 视频时长（秒）
   * @default 5
   *
   * duration 即 frames 二该一即可，frames 对传又该视该子 duration
   * SeeDance 1.5 pro 支持传统配置为冬
   * 1 即对承担该包：支持 [4,12] 即根据的该的对（两根据）、即即设即全该对及
   * 2 不即承担该包：[2,8]（信息）。范围该该该该 API 返回接 duration 字段转此。
   *
   * 轨迹（仪支持对）
   */
  duration?: number;
  /**
   * 帧率（fps）
   * @default 24
   *
   * 说明：仪支持对
   */
  framespersecond?: number;
  /**
   * 是否添加水印
   * @default false
   */
  watermark?: boolean;
  /**
   * 随机种子
   * @default -1
   * @range -1 - 4294967295
   *
   * 随机种子，-1表示随机
   */
  seed?: number;
  /**
   * 是否固定摄像机
   * @default false
   */
  camerafixed?: boolean;
  /**
   * 是否为草稿模式（仅Seedance 1.5 pro支持）
   * @default false
   *
   * 说明：
   * - true: 开启草稿模式，耗时减速视频质量可该包，视频质量。主模式仅为 prompt 需正全且行进项链。项该 token 数量为正在草稿视频（使用该场景仅促使合该）。不支持该场景提出根据。不支持该场景该即项根据。
   * - false: 关闭草稿模式，正常生成一根据。
   *
   * 设照
   * 开启草稿模式时，视频质量 480p 分辨率正在草稿视频（使用该场景仅该合该）。不支持该场景该即该根据。
   */
  draft?: boolean;
}

export interface VolcesSeedance15ProResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_seedance_1_5_pro
 *
 * <p>通过火山引擎SeeDance 1.5 Pro API创建视频生成任务。</p>
 * <p>API Documentation: https://www.volcengine.com/docs/seedance/api</p>
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSeedance15Pro } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * // 文生视频
 * const result = await volcesSeedance15Pro({
 *   content: [
 *     {
 *       type: 'text',
 *       text: 'A beautiful sunset over the ocean'
 *     }
 *   ],
 *   resolution: '720p',
 *   duration: 5
 * });
 *
 * // 图生视频
 * const result2 = await volcesSeedance15Pro({
 *   content: [
 *     {
 *       type: 'text',
 *       text: 'A person walking'
 *     },
 *     {
 *       type: 'image_url',
 *       image_url: {
 *         url: 'https://example.com/image.jpg',
 *         role: 'first_frame'
 *       }
 *     }
 *   ],
 *   resolution: '720p',
 *   duration: 5
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSeedance15ProParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSeedance15Pro(
  params: VolcesSeedance15ProParams,
): Promise<VolcesSeedance15ProResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seedance_1_5_pro',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeedance15ProResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          // Validate URL before adding to results
          validateResourceUrl(resource, 'video');

          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
